import API from './index';

const api = {
    getUserAccounts({ page, pageSize, sort, isDesc, param }) {
        return API.authAPI({
            url: '/user/get-user-byParams',
            method: 'GET',
            params: {
                page,
                pageSize,
                sort,
                isDesc,
                param
            },
        });
    },
    getUserGroups() {
        return API.authAPI({
            url: '/group/get-user-group',
            method: 'GET',
            params: null,
        });
    },
    createUserAccount(data) {
        return API.authAPI({
            url: '/user/add-user-account',
            method: 'POST',
            data,
        });
    },
    updatePassword(data) {
        return API.authAPI({
            url: '/user/update-password',
            method: 'POST',
            data,
        });
    },
    getUserAccountDetail(userid) {
        return API.authAPI({
            url: `/user/user-detail?userid=${userid}`,
            method: 'GET',
        });
    },
    updateUserAccount(data) {
        return API.authAPI({
            url: '/user/user-edit',
            method: 'POST',
            data,
        });
    },
    updateUserAccountStatus(data) {
        return API.authAPI({
            url: `/user/update-user-accountStatus`,
            method: 'POST',
            data,
        });
    },
};

export default api;
